"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSession = exports.isDoiDSO = exports.getAppidFromParamIfPresent = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = _interopRequireDefault(require("axios"));
var _ciamAuthWebClientLib = require("@eon-funke/ciam-auth-web-client-lib");
var _cicUtils = require("@eon-funke/cic-utils");
var _mhaConfig$SSO;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// const baseApiURLs = 'https://i-api.eon.de/grid/cscn-customer-srv';
var cscData = (0, _cicUtils.getIdDataset)('cscn-config', 'props');
var cscConfig = cscData ? JSON.parse((0, _cicUtils.decodeEntities)(cscData)) : null;
var mhaData = (0, _cicUtils.getIdDataset)('iconn-mhap-config', 'props');
var mhaConfig = mhaData ? JSON.parse((0, _cicUtils.decodeEntities)(mhaData)) : null;
var cicDomainsJson = (0, _cicUtils.getIdDataset)('CSCN_MW_URL', 'cicMiddlewareDomains');
var domain = (0, _cicUtils.getIdDataset)('CSCN_MW_URL', 'middlewareDomain');
var isDoiDSO = exports.isDoiDSO = function isDoiDSO(DSO) {
  return DSO;
};
var getAppidFromParamIfPresent = exports.getAppidFromParamIfPresent = function getAppidFromParamIfPresent() {
  var _getQParameterByName;
  return (_getQParameterByName = (0, _cicUtils.getQParameterByName)('appid')) === null || _getQParameterByName === void 0 ? void 0 : _getQParameterByName.slice(3);
};
var mhaDomains = {
  account: mhaConfig === null || mhaConfig === void 0 ? void 0 : (_mhaConfig$SSO = mhaConfig.SSO) === null || _mhaConfig$SSO === void 0 ? void 0 : _mhaConfig$SSO.accountApi
};
var kundenportalDomains = cicDomainsJson ? _objectSpread(_objectSpread({}, JSON.parse(cicDomainsJson)), {}, {
  csc: domain
}) : {
  csc: domain || ""
};
var possibleMwDomains = {
  "app006": mhaDomains,
  "app0061": mhaDomains,
  "app0062": mhaDomains,
  "app0063": mhaDomains,
  "app010": mhaDomains,
  "app0101": mhaDomains,
  "app0102": mhaDomains,
  "app0103": mhaDomains,
  "app004": kundenportalDomains,
  "app0041": kundenportalDomains,
  "app001": kundenportalDomains,
  "app0011": kundenportalDomains
};
var possibleConfigs = {
  "app006": mhaConfig,
  "app0061": mhaConfig,
  "app0062": mhaConfig,
  "app0063": mhaConfig,
  "app004": cscConfig,
  "app0041": cscConfig,
  "app001": cscConfig,
  "app0011": cscConfig,
  "app010": mhaConfig,
  "app0101": mhaConfig,
  "app0102": mhaConfig,
  "app0103": mhaConfig
};
var appid = getAppidFromParamIfPresent();
var currentConfig = possibleConfigs["app".concat(appid)] || mhaConfig;
var currentMwDomains = possibleMwDomains["app".concat(appid)] || mhaDomains;
var CONFIG = {
  CHANNEL_CONFIG: {
    anonymMR: 'ANONYMOUSMETERREADING',
    loggedInCsc: 'CSC'
  },
  AEM_CONFIG: _objectSpread(_objectSpread({
    isOmApp: (appid === null || appid === void 0 ? void 0 : appid.indexOf("010")) === 0,
    appid: appid,
    cscConfigAdded: !!cscConfig
  }, currentConfig), {}, {
    isDkePage: (0, _cicUtils.getInputValueIfExists)('dke-page') === 'true',
    isAuthorMode: (0, _cicUtils.getInputValueIfExists)('author_mode') !== null,
    middlewareDomains: currentMwDomains
  })
};
// eslint-disable-next-line no-console
console.log("CURRENTCONF", appid, currentConfig);
var _default = exports.default = CONFIG;
var setSession = exports.setSession = function setSession() {
  var _CONFIG$AEM_CONFIG;
  if (!(CONFIG === null || CONFIG === void 0 ? void 0 : (_CONFIG$AEM_CONFIG = CONFIG.AEM_CONFIG) === null || _CONFIG$AEM_CONFIG === void 0 ? void 0 : _CONFIG$AEM_CONFIG.SSO)) {
    // eslint-disable-next-line no-console
    console.warn('SSO config is unavailable! -- setSession');
    return;
  }
  _cicUtils.RestHelper.initBaseURLs(localStorage.mockMode && localStorage.mockMode === '1' ? JSON.parse(localStorage.mockUrls) : CONFIG.AEM_CONFIG.middlewareDomains);
  _ciamAuthWebClientLib.SessionHandler.setConfig({
    loginPageExitUrl: CONFIG.AEM_CONFIG.SSO.ssoLogout,
    loginPageUrl: CONFIG.AEM_CONFIG.SSO.ssoLoginUrl,
    clientId: CONFIG.AEM_CONFIG.SSO.clientId,
    loginSuccessPath: CONFIG.AEM_CONFIG.SSO.loginSuccessPath,
    authorizationUrl: CONFIG.AEM_CONFIG.SSO.ssoExchangeUrl,
    refereshUrl: CONFIG.AEM_CONFIG.SSO.ssoExchangeUrl
  }, {
    post: function post(url, params) {
      return _axios.default.post(url, params);
    }
  });
};